import React from "react";
// import successImg from "../../assets/images/successfull.gif";
import CustomModal from "../../components/common/customModal";
import { Box } from "@mui/system";
import { CircularProgress, Typography } from "@mui/material";

interface AwardAcceptedProps {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  rewardMessage: string;
  isLoading: boolean;
}

const AwardAccepted: React.FC<AwardAcceptedProps> = ({
  open,
  onClose,
  onSave,
  rewardMessage,
  isLoading,
}) => {
  return (
    <CustomModal
      borderBottom="0px"
      open={open}
      saveTitle="Ok"
      width={500}
      handleClose={onClose}
      title={""}
      onSave={onSave}
    >
      <div>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          {" "}
          {/* <img
            src={successImg}
            alt="Success"
            style={{ width: "40%", height: "10%", marginLeft: "10%" }}
          /> */}
        </Box>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          {isLoading ? (
            <div style={{ textAlign: "center", padding: "2rem" }}>
              <CircularProgress style={{ color: "#FFFFFF" }} />
            </div>
          ) : (
            <Typography
              sx={{
                textAlign: "center",
                my: 2,
                fontSize: "16px",
                fontWeight: "bold",
              }}
            >
              {rewardMessage}
            </Typography>
          )}
        </Box>
      </div>
    </CustomModal>
  );
};

export default AwardAccepted;
